<template>
  <div class="home">
    <div class="navbar-container bg-light">
      <HeroSection />
      <KategoriSection />
      <PoSection />
      <ProductSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import HeroSection from "@/components/HeroSection.vue";
import KategoriSection from "@/components/KategoriSection.vue";
import PoSection from "@/components/PoSection.vue";
import ProductSection from "@/components/ProductSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "Home",
  components: {
    HeroSection,
    KategoriSection,
    PoSection,
    ProductSection,
    FooterSection
  }
};
</script>

